// import { Theme } from '@oberoninternal/travelbase-ds/constants/theme';
import ExtendedTheme from './ExtendedTheme';

const brand = process.env.NEXT_PUBLIC_BRAND;

// eslint-disable-next-line import/no-dynamic-require
const theme: ExtendedTheme = require(`./theme.${brand}`).default;

export default theme;
